<span class="inline-flex justify-center items-center rounded-full bg-brand-darkBlue text-xs font-medium text-white ring-1 ring-inset ml-2 w-6 h-6">
    <ng-content></ng-content>
</span>